import { useModal } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import { messages } from '@xengage/gw-platform-translations';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { MockUpUtil } from '@xengage/gw-portals-util-js';
import _ from 'lodash';
import { useCallback, useState } from 'react';

const useWizardExit = history => {
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const translator = useTranslator();
    const [isSavingSubmission, setSavingSubmission] = useState(false);
    const { showConfirm } = useModal();
    const onExit = useCallback(
        ({ wizardSnapshot: submissionV }) => {
            const periodStatus = _.get(
                submissionV,
                'baseData.periodStatus.value.code'
            );
            if (periodStatus === 'Bound') {
                return true;
            }

            return showConfirm({
                title: translator(messages.wantToCancel),
                message: translator(messages.infoWillBeSavedAsDraft),
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.yes,
                cancelButtonText: messages.close,
            }).then(async results => {
                if (results === 'cancel' || results === 'close') {
                    return _.noop();
                }
                const isStatusQuoted =
                    _.get(submissionV, 'baseData.periodStatus.value.code') ===
                    'Quoted';

                let serverCall = LoadSaveService.updateDraftSubmission;

                if (isStatusQuoted) {
                    serverCall = LoadSaveService.updateQuotedSubmission;
                }

                const submission = _.get(submissionV, 'value');
                const dataToSave = MockUpUtil.setMockData(
                    submission,
                    'quote.PremierLE'
                );
                setSavingSubmission(true);

                serverCall(dataToSave).then(() => {
                    history.push('/');
                });
            }, _.noop);
        },
        [LoadSaveService, history, showConfirm, translator]
    );

    return [isSavingSubmission, onExit];
};

export default useWizardExit;
